import * as OM from '@/model';

export class AddPrenotazioneCommentVm
{
    prenotazioneIdentifier: string;
    allegato: File;
    text: string;
    notifyUser: boolean
}

export class WsPresentMessage
{
    chatRoomName: string;
    chatRoomIdentifier: string;
    userIdentifier: string;
}

export class WsDisableMessage
{
    disable: boolean;
    chatRoomIdentifier: string;
}

export class WsRemoveMessage
{
    messageIdentifier: string;
    chatRoomIdentifier: string;
}

export class WsLeaveChatRoom
{
    chatRoomIdentifier: string;
    userIdentifier: string;
}

export class WsConnectToChatRoom
{
    chatRoomIdentifier: string;
    userIdentifier: string;
}

export class WsNotificationMessage
{
    notificationData: OM.InAppNotification;
}

export class WsMessage<T> {
    type: string;
    content: T;
}

export class AddCommentEvent {
    fileList: File[];
    text: string;
}

export class AddCommentVm
{
    fileList: File[];
    text: string;
    entityIdentifier: string;
}

export class SendMessageVm
{
    fromBackend: boolean;
    chatRoomIdentifier: string;
    text: string;
    senderName: string;
    senderIdentifier: string;
    clienteIdentifier: string;
    quotedMessage: OM.QuotedMessage;
}

export class CreateUserPaymentRequestVm
{
    amount: number;
    date: string;
    userIdentifier: string;
    useRitenutaAcconto: boolean;
    attachment: File;
    constructor(){
        this.amount = null;
        this.date = "";
        this.userIdentifier = "";
        this.useRitenutaAcconto = false;
        this.attachment = null;
    }
}

export class UploadFileVm
{
    entityIdentifier: string;
    file: File;
}

export class UploadVideoReviewVm
{
    userIdentifier: string;
    villageIdentifier: string;
    file: File | Blob;
}

export class VillageGlobalGalleryItemWithSize extends OM.VillageGlobalGalleryItem {
    isWide: boolean;
    isTall: boolean;
}

export class RegisterVm extends OM.RegisterVm {
    referralCode: string;
}
